import { Box, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { appendMunicipioToUrl } from "../../hooks/useMunicipioFromUrl";
import { getTenantConfig } from "../../services/api";
import { getMunicipio } from "../../services/data";
import { hasAuditoriaSinter } from "../../utils/auditoriaSinter";

type Aba = {
  label: string;
  path: string;
};

const ABAS_PADRAO: Aba[] = [
  { label: "AUDITORIA DO SISTEMA", path: "/auditoria/sistema" },
  { label: "AUDITORIA DO MÓDULO DE CADASTRO", path: "/auditoria/cadastro" },
  { label: "AUDITAR USUÁRIOS", path: "/auditoria/usuarios" },
];

const ABA_SINTER: Aba = { label: "AUDITORIA SINTER", path: "/auditoria/sinter-registros" };

export default function AuditoriaTabs() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const municipio = getMunicipio();

  const { data: auditoriaSinter } = useQuery({
    queryKey: ["sinter-auditoria-disponivel", municipio],
    queryFn: async () => hasAuditoriaSinter(await getTenantConfig()),
  });

  const abas = auditoriaSinter ? [...ABAS_PADRAO, ABA_SINTER] : ABAS_PADRAO;

  return (
    <Box sx={{ width: "90%", margin: "auto", display: "flex", justifyContent: "center", marginTop: 6 }}>
      {abas.map((aba) => {
        const ativa = location.pathname.startsWith(aba.path);

        return (
          <Box
            key={aba.path}
            sx={{
              width: "50%",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              paddingBottom: 3,
              cursor: "pointer",
              borderBottom: ativa ? `1px ${theme.palette.success.main} solid` : "none",
              color: ativa ? theme.palette.success.main : "inherit",
            }}
            onClick={() => navigate(appendMunicipioToUrl(aba.path))}
          >
            {aba.label}
          </Box>
        );
      })}
    </Box>
  );
}
